import { config } from "../config/env";

const RESERVED_HOSTS = new Set(["www", "api"]);

export function normalizeTenantSlug(value) {
  let candidate = String(value || "").trim().toLowerCase();
  if (!candidate) return null;
  candidate = candidate.replace(/^https?:\/\//, "").split(/[/?#]/)[0].split(":")[0];
  const suffix = `.${config.rootDomain.toLowerCase()}`;
  if (candidate.endsWith(suffix)) candidate = candidate.slice(0, -suffix.length);
  if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(candidate) || RESERVED_HOSTS.has(candidate)) return null;
  return candidate;
}

export function getTenantSlugFromHostname(hostname = window.location.hostname) {
  const host = hostname.toLowerCase().split(":")[0];
  if (host === "localhost" || host === "127.0.0.1") {
    return new URLSearchParams(window.location.search).get("tenant");
  }
  if (host === config.rootDomain || host === `www.${config.rootDomain}`) return null;
  const suffix = `.${config.rootDomain}`;
  if (!host.endsWith(suffix)) return null;
  return normalizeTenantSlug(host.slice(0, -suffix.length));
}
